import { z } from 'zod';

import { BaseFlowDecorationSchema, FlowDecorationType } from './base.js';
import { FlowDecorationColor } from './constants.js';

export enum StickyNoteFontSize {
  Small = 'Small',
  Medium = 'Medium',
  Large = 'Large',
}

export const StickyNoteDataSchema = z.object({
  author: z.string().default(''),
  color: z.enum(FlowDecorationColor).default(FlowDecorationColor.Yellow),
  fontSize: z.enum(StickyNoteFontSize).default(StickyNoteFontSize.Medium),
  markdownContent: z.string().default(''),
});
export type StickyNoteData = z.infer<typeof StickyNoteDataSchema>;

export const StickyNoteNodeSchema = BaseFlowDecorationSchema.extend({
  decorationType: z.literal(FlowDecorationType.StickyNote),
  data: StickyNoteDataSchema,
  dimensions: z.object({
    width: z.number().default(240).optional(),
    height: z.number().default(240).optional(),
  }),
});
export type StickyNoteNode = z.infer<typeof StickyNoteNodeSchema>;
